import styles from "../Daetong.module.css"
import { useEffect, useState } from "react";
import $ from "jquery";
import { Link } from "react-router-dom";




export default function UnseResult({Loading, Constellation, personaList }) {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const APIKEY = process.env.REACT_APP_UNSE_API_KEY;
    const memberId = localStorage.getItem('daetong_memberId');
    const unseLogId = localStorage.getItem('daetong_unseLogId');
    const personaId = localStorage.getItem('daetong_personaId');
    const [data, setData] = useState([]);
    const siteCode = process.env.REACT_APP_SITE_CODE_DAETONG;

    // personaList에서 선택된 페르소나 찾기
    const selectedPersona = personaList?.find(p => String(p.ID) === String(personaId));
    
    useEffect(() => {
        if(unseLogId && memberId) {
            $.ajax({
                url: `${API_BASE_URL}/getUnseResult`,
                type: "POST",
                contentType: "application/json",
                dataType: "json",
                data: JSON.stringify({
                    "member_id": memberId,
                    "unse_log_id": unseLogId,
                    "site_code": siteCode
                }),
                cache: false,
                headers: {
                    APIKEY: APIKEY,
                },
                success: function (res) {
                    // console.log(res);
                    if (res.code != "0") {
                        alert(res.msg); return false;
                    }
                    setData(res);
                    // console.log("응답:", res);
                },
                error: function (xhr, status, err) {
                    console.error("에러:", err);
                    // console.log("상태:", xhr.status, "응답:", xhr.responseText);
                },
            });
        } else {
            alert("잘못된 접근입니다.");
            window.location.href="/";
        }
        
    },[]);

    if (!data) {
        return <Loading Constellation={Constellation}/>;
    } 

    return (
        <div className="UnseResultPage_inner UnseResultPage_daetong">
            <div className={`UnseResultContent ${styles.UnseResultContent_daetong}`}>
                <p className="content_scroll top">
                    <img src={process.env.PUBLIC_URL + '/daetongImg/content_scroll.png'} alt='' />
                </p>
                <p className="content_scroll bottom">
                    <img src={process.env.PUBLIC_URL + '/daetongImg/content_scroll.png'} alt='' />
                </p>
                <div className="UnseResultDaetong_box">
                    <div className={styles.unseResultHeader}>
                        <h4 className="userInfo">
                            {data.title}
                        </h4>
                        {/* 역술인 이미지 - 타이틀 우측 */}
                        {selectedPersona && selectedPersona.IMAGE_PATH && (
                            <div className={styles.personaResultImage}>
                                <img src={process.env.PUBLIC_URL + selectedPersona.IMAGE_PATH} alt={selectedPersona.NAME || '역술인'} />
                                {selectedPersona.NAME && <span className={styles.personaResultName}>{selectedPersona.NAME}</span>}
                            </div>
                        )}
                    </div>
                    <h3 className={`subTitle ${styles.subTitle_daetong}`}>
                        {data.subtitle}
                        <span className="line"></span>
                    </h3>
                    <div className="unseResultText" dangerouslySetInnerHTML={{__html: data.result}}/>
                </div>
            </div>
        </div>
    )
}